// document.addEventListener("DOMContentLoaded", function () {
//   const popupOverlay = document.querySelector(".professional-popup-overlay");
//   const closeBtn = document.querySelector(".close-popup");
//   const form = document.querySelector("#ContactForm");
//   const pdfButtons = document.querySelectorAll(".pdf-button.trigger-form");
//   const link = document.querySelector('a[href="#for-health-profe-page"]');
//   const targets = document.querySelectorAll(
//     ".for-health-profe-page, .product-pdf-buttons, .faq-accordion-section"
//   );

//   const COOKIE_NAME = "professionalFormSubmitted";
//   const COOKIE_DAYS = 365;

//   // ---------- COOKIE HELPERS ----------
//   function setCookie(name, value, days) {
//     const d = new Date();
//     d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
//     document.cookie =
//       name + "=" + encodeURIComponent(value) + ";expires=" + d.toUTCString() + ";path=/";
//   }

//   function getCookie(name) {
//     const nameEQ = name + "=";
//     const ca = document.cookie.split(";");
//     for (let c of ca) {
//       c = c.trim();
//       if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
//     }
//     return null;
//   }

//   // ---------- CLOSE POPUP ----------
//   closeBtn?.addEventListener("click", () => (popupOverlay.style.display = "none"));
//   popupOverlay?.addEventListener("click", (e) => {
//     if (e.target === popupOverlay) popupOverlay.style.display = "none";
//   });

//   // ---------- ON PAGE LOAD ----------
//   const hasSubmitted = !!getCookie(COOKIE_NAME);

//   // If cookie exists → keep those sections visible
//   if (hasSubmitted) {
//     targets.forEach((el) => el.classList.add("active-rajpdf"));
//   } else {
//     targets.forEach((el) => el.classList.remove("active-rajpdf"));
//   }

//   // ---------- LINK CLICK ----------
//   if (link) {
//     link.addEventListener("click", function (e) {
//       e.preventDefault();
//       if (hasSubmitted) {
//         // Already submitted → show sections directly
//         targets.forEach((el) => el.classList.add("active-rajpdf"));
//       } else {
//         // Not submitted yet → open popup
//         popupOverlay.style.display = "flex";
//         popupOverlay.scrollTop = 0;
//       }
//     });
//   }

//   // ---------- PDF BUTTONS ----------
//   pdfButtons.forEach((button) => {
//     button.addEventListener("click", function (e) {
//       e.preventDefault();
//       const pdfLink = this.dataset.pdfLink;
//       if (pdfLink) window.open(pdfLink, "_blank");
//     });
//   });

//   // ---------- FORM SUBMIT ----------
//   form?.addEventListener("submit", function () {
//     setCookie(COOKIE_NAME, "1", COOKIE_DAYS);
//     // reload page after short delay
//     setTimeout(() => {
//       window.location.reload();
//     }, 800);
//   });

//   // ---------- AFTER REDIRECT (Shopify contact_posted) ----------
//   const urlParams = new URLSearchParams(window.location.search);
//   if (urlParams.has("contact_posted")) {
//     setCookie(COOKIE_NAME, "1", COOKIE_DAYS);

//     // Add active class (show all sections)
//     targets.forEach((el) => el.classList.add("active-rajpdf"));

//     // Open stored PDF if any (optional)
//     const pdfLink = localStorage.getItem("selectedPdfLink");
//     if (pdfLink) {
//       setTimeout(() => {
//         window.open(pdfLink, "_blank");
//         localStorage.removeItem("selectedPdfLink");
//       }, 800);
//     }
//   }
// });






document.addEventListener("DOMContentLoaded", function () {

  const profeLink = document.querySelector('a.for-health-profe-page');
  const popup = document.querySelector("#FBpopupFormWrapper-Ws-YOauv09eSU1Og2C1k2w");

  // -----------------------------
  // COOKIE FUNCTIONS
  // -----------------------------
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
      let c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }


  // -----------------------------
  // SUCCESS AFTER SUBMIT
  // -----------------------------
  function activateAfterSubmit() {

    // add success class
    document.querySelectorAll(".for-health-profe-page, .product-pdf-buttons, .faq-accordion-section")
      .forEach(el => el.classList.add("active-rajpdf"));

    // hide popup forever
    if (popup) popup.style.display = "none";

    // set COOKIE → popup never opens again
    setCookie("raj_form_done", "1", 10); // 10 days cookie

    console.log("✔ COOKIE SET — popup disabled forever");
  }


  // -----------------------------
  // 1) CHECK COOKIE → Popup Block
  // -----------------------------
  if (getCookie("raj_form_done") === "1") {

    // block popup opening when link clicked
    if (profeLink) {
      profeLink.addEventListener("click", function (e) {
        e.preventDefault();   // popup will never open
        console.log("✔ Link clicked — popup blocked because cookie found");
      });
    }

    // add class again (safe)
    activateAfterSubmit();

    return; // stop code here
  }


  // -----------------------------
  // 2) Detect Form Submit
  // -----------------------------
  const formSubmitCheck = new MutationObserver(() => {
    const done = document.querySelector(".after_form_submit[style*='display: block']");

    if (done) {
      activateAfterSubmit();
      formSubmitCheck.disconnect();
    }
  });

  formSubmitCheck.observe(document.body, { childList: true, subtree: true });


  // -----------------------------
  // 4) Before submit → popup opens normally
  // -----------------------------
  if (profeLink) {
    profeLink.addEventListener("click", function () {
      if (!getCookie("raj_form_done")) {
        console.log("Popup opened BEFORE submit");
      }
    });
  }

});










// ayouthveda-slider Read less Read more
document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.ayouthveda_slide .rightfirstcontent .widthcontrol');

  containers.forEach(container => {

    const style = window.getComputedStyle(container);
    let lineHeight = parseFloat(style.lineHeight);
    if (isNaN(lineHeight)) {
      const fontSize = parseFloat(style.fontSize) || 14;
      lineHeight = Math.round(fontSize * 1.2);
    }

    const maxLines = 12;
    const maxHeight = Math.round(lineHeight * maxLines);

    if (container.scrollHeight <= maxHeight + 1) return;

    container.classList.add('clamped');
    container.style.maxHeight = maxHeight + 'px';
    const btn = document.createElement('button');
    btn.className = 'read-more-btn';
    btn.type = 'button';
    btn.textContent = 'Read more';

    let expanded = false;
    btn.addEventListener('click', function () {
      expanded = !expanded;
      if (expanded) {
        container.style.maxHeight = container.scrollHeight + 'px';
        btn.textContent = 'Read less';
      } else {
        container.style.maxHeight = maxHeight + 'px';
        btn.textContent = 'Read more';
      }
    });
    container.insertAdjacentElement('afterend', btn);
  });
});



